// Cleaned and Optimized CartInfo Component

import { useRouter } from "next/router";
import { useContext, useEffect, useRef, useState } from "react";

import { getCookies } from "cookies-next";
import { useTranslation } from "next-i18next";
import { useCart } from "@/contexts/cart/CartContext";
import { ModalContext } from "@/pages/_app";

import { validatePrice } from "@/utils/product";
import useOnClickOutside from "@/hooks/useOnClickOutside";

import Star from "../../icons/Star";

import ProductFees from "./ProductFees";
import Info from "./Info";
import FrequentlyBoughtTogetherSwiper from "./FrequentlyBoughtTogetherSwiper";
import LastSection from "./LastSection";
import BannerSection from "./BannerSection";
import CloseCircle from "@/components/icons/close-circle";

function CartInfo({ Context }) {
  const { t } = useTranslation("common");
  const { region_id } = getCookies();
  const { push, locale } = useRouter();
  const { cart } = useCart();
  const cartModel = useContext(ModalContext);

  const cartInfoRef = useRef(null);
  useOnClickOutside([cartInfoRef], () =>
    Context?.dispatch({ type: "closeModal", payload: "" })
  );

  const [
    frequentlyBoughtTogetherProducts,
    setFrequentlyBoughtTogetherProducts,
  ] = useState(cartModel?.state.relatedProducts);

  useEffect(() => {
    setFrequentlyBoughtTogetherProducts(cartModel?.state.relatedProducts);
  }, [cartModel?.state.relatedProducts]);

  const totalPrice = cart?.cartItems?.reduce((total, item) => {
    const price = validatePrice(
      item?.prices_with_tax || item?.extension_attributes
    );
    return total + (+price?.specialPrice || +price?.originalPrice || 0);
  }, 0);

  return (
    <div className="fixed top-0 left-0 w-screen bg-lightblack z-[5000] min-h-screen overflow-y-auto gray-scrollbarV2 overflow-hidden">
      <div
        ref={cartInfoRef}
        className={`w-[455px] min-h-screen max-[570px]:w-full bg-white absolute top-0 left-0 rounded-r-2xl rounded-br-xl`}
      >
        <div className="flex items-center justify-between p-4 bg-white rounded-r-2xl">
          <div className="flex items-center">
            <Star />
            <h4 className="mx-2 text-lg font-semibold">{t("GreatChoice")}</h4>
          </div>
          <CloseCircle
            onClick={() =>
              Context?.dispatch({ type: "closeModal", payload: "" })
            }
            size="20px"
            className="cursor-pointer"
          />
        </div>

        <div className="relative">
          <div className="flex flex-col gap-2.5 h-full px-4 my-4">
            {cart?.cartItems?.map((item) => {
              const price = validatePrice(
                item?.prices_with_tax || item?.extension_attributes
              );
              const availableProductFees = (
                item?.product_fees || item?.extension_attributes?.product_fees
              )?.filter((fee) =>
                fee?.region_ids?.includes(region_id || "1101")
              );

              return (
                <div
                  key={item?.item_id}
                  className="flex flex-col border-gray-100 border-b-2 pb-2 last:border-none"
                >
                  <Info {...{ item, price, t }} />
                  <ProductFees {...{ availableProductFees, item, locale, t }} />
                </div>
              );
            })}
          </div>

          <FrequentlyBoughtTogetherSwiper
            {...{ frequentlyBoughtTogetherProducts, locale, t }}
          />

          <BannerSection {...{ locale, t }} />

          <LastSection {...{ totalPrice, Context, t, push }} />
        </div>
      </div>
    </div>
  );
}

export default CartInfo;
